export default __webpack_public_path__ + "static/media/lu.b50da494.svg";